import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { TabsWrapperSecondary, TabItemSecondary } from 'src/domains/layouts/shared/tabs/Tabs.style';



export const NotificationPageFilter = observer(() => {
    const { notificationPageState } = useAppStateContext();
    const { selectFilterImage, selectFilterVideo, selectedNotificationPageType, isEditMode} = notificationPageState;
    return (
        <TabsWrapperSecondary>
            <TabItemSecondary disabled={isEditMode} isActive={selectedNotificationPageType === 'image'} onClick={selectFilterImage}>{isEditMode && selectedNotificationPageType === 'image' ? 'Edit ' : 'Create '}Image Promo</TabItemSecondary>
            <TabItemSecondary disabled={isEditMode} isActive={selectedNotificationPageType === 'video'} onClick={selectFilterVideo}>{isEditMode && selectedNotificationPageType === 'video' ? 'Edit ' : 'Create '}Video Promo</TabItemSecondary>
        </TabsWrapperSecondary>
    );
});
